<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="area_region"
              :label="$t('attributes.group')"
            >
              <span style="font-size: 18px;">{{ form.region_name }}</span>
            </form-group>
            <form-group
              name="name"
              horizontal
              :label="$t('attributes.catalog')"
            >
              <b-autocomplete
                ref="traveler_type_input"
                v-model="selectedCatalogText"
                name="TravelerTypeName"
                field="name"
                :data="catalogs"
                :placeholder="
                  $t('message.please_input') + $t('attributes.catalog_name')
                "
                :open-on-focus="false"
                @typing="onLoadCatalogs"
                @select="onSelectedCatalog"
                :disabled="!isNew"
              >
                <template #default="props">
                  <p>
                    (
                    <!-- eslint-disable-next-line-->
                    <span v-text="props.option.catalog_no"></span>
                    )
                    {{ props.option.name }}
                  </p>
                </template>
                <template #empty>
                  {{
                    form.region_list_no
                      ? loadingCatalogs
                        ? $t('attributes.searching')
                        : $t('attributes.not_found')
                      : $t('message.please_input') +
                        $t('attributes.catalog_name')
                  }}
                </template>
              </b-autocomplete>
            </form-group>
            <form-group
              name="region_list_catalog_name"
              horizontal
              :label="$t('attributes.name')"
            >
              <b-input
                v-model="form.region_list_catalog_name"
                name="region_list_catalog_name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
              >
              </b-input>
            </form-group>
            <form-group
              name="sort"
              horizontal
              expanded
              :label="$t('attributes.sort')"
            >
              <b-select
                v-model="form.region_list_catalog_sort"
                name="region_list_sort"
              >
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ isNew ? $t('attributes.add') : $t('attributes.update') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { AREA_API } from '@/utils/apis'
import debounce from 'lodash/debounce'
import notifyService from '@/services/notifyService'

export default {
  name: 'AreaRegionCatalogForm',
  props: {
    regionCatalog: {
      type: Object,
      required: true
    }
  },
  data() {
    const isNew = this.regionCatalog.is_add
    const formTitle =
      (isNew ? this.$t('attributes.add') : this.$t('attributes.update')) +
      this.$t('attributes.area') +
      this.$t('attributes.group') +
      this.$t('attributes.catalog')
    return {
      isNew,
      formTitle,

      labelPosition: 'on-border',

      loading: false,
      sending: false,
      loadingCatalogs: false,

      form: this.extractFormValues(this.regionCatalog),
      sortOptions: [...Array(20).keys()].map(i => i + 1),
      catalogs: [],
      catalog: null,
      selectedCatalogText: this.regionCatalog.catalog_no
    }
  },
  validations: {
    form: {
      is_add: { required },
      area_code: { required },
      catalog_no: {},
      region_name: {},
      region_list_catalog_name: { maxlength: 50 },
      region_list_catalog_sort: { required },
      region_list_no: { maxlength: 200 }
    }
  },
  mounted() {
    this.loadCatalog()
  },
  methods: {
    extractFormValues(data) {
      return {
        is_add: data.is_add,
        area_code: data.area_code,
        catalog_no: data.catalog_no,
        region_name: data.region_name,
        region_list_catalog_name: data.region_list_catalog_name,
        region_list_catalog_sort: data.region_list_catalog_sort,
        region_list_no: data.region_list_no
      }
    },
    async loadCatalog() {
      try {
        if (this.form.catalog_no !== '') {
          const api = `${AREA_API}/${this.form.catalog_no}/catalog`
          const res = await this.axios.get(api)
          this.catalog = res.data.data
          this.selectedCatalogText = this.catalog.name
        }
      } catch (e) {
        this.catalog = null
        this.selectedCatalogText = ''
      }
    },
    async loadCatalogsSearch() {
      try {
        const params = {
          area_code: this.form.area_code,
          text: this.selectedCatalogText
        }
        this.loadingCatalogs = true
        const api = `${AREA_API}/catalogs/search`
        const res = await this.axios.get(api, { params })
        this.catalogs = res.data.data
      } catch (e) {
        this.catalogs = []

        notifyService.fetch_error('region', e)
      } finally {
        this.loadingCatalogs = false
      }
    },
    onLoadCatalogs: debounce(function() {
      this.loadCatalogsSearch()
    }, 500),
    onSelectedCatalog(option) {
      if (option !== null) {
        this.selectedCatalogText = option.name
        this.form.catalog_no = option.catalog_no
        if (this.form.region_list_catalog_name === '') {
          this.form.region_list_catalog_name = option.name
        }
      }
    },
    onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
